import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { uploadBytes, getStorage, ref, getDownloadURL, getBlob, listAll } from "firebase/storage";
import { storage } from "../../../../utilities/firebase";
import axios from "axios";
import moment from "moment";
import AddDocuments from "../../../blacklist/additional-details";
import Cookies from "js-cookie";
import { CircleLoader } from "react-spinners";

const DetailEdit = (props) => {
    

    const [showDocs, setShowDocs] = useState(false);
    const [IDdownload, setIDdownload] = useState('ID document');
    const [Companydownload, setCompanyRegdownload] = useState('company registration');
    const [Addressdownload, setAddressdownload] = useState('proof of address');
    const [Contractdownload, setContractdownload] = useState('contract/agreement');
    const [item, setMyBlacklist] = useState(null);
    const [change, setChange] = useState(false);
    const [checkCount, setCheckCount] =useState(0);

    const [showCompany, setShowCompany] = useState(true);
    const [showRep, setShowRep] = useState(false);

    const [companyDocuments, setCompanyDocuments] = useState([])
    const [additionalDocuments, setAdditionalDocuments] = useState([])
    const [incidentDocuments, setIncidentDocuments] = useState([])
    const [peopleDocuments, setPeopleDocuments] = useState([])


    const [IDname, setIDname] = useState('');
    const [address, setAddressName] = useState('');
    const [contract, setContractName] = useState('');


    const [incidentDate, setIncidentDate] = useState();
    const [incidentInfo, setIncidentInfo] = useState('')
    const [amountApplied, setAmountApplied] = useState();
    const [amountLost, setAmountLost] = useState();
    const [caseNumber, setCaseNumber] = useState();

    const [companyName, setCompanyName] = useState();
    const [companyReg, setCompanyReg] = useState('');

    const [companyType, setCompanyType] = useState();
    const [companyVAT, setCompanyVAT] = useState();
    const [companyAddress, setCompanyAddress] = useState();
    const [companyPhone, setCompanyPhone] = useState();
    const [companyEmail, setCompanyEmail] = useState();

    

    const [blacklist, setBlacklist] = useState([])
    const [representatives, setRepresentatives] = useState([])
    
    const user_id = Cookies.get('token_id')
    

    const reference = props.reference;

    useEffect(() => {
        if (item != null) {
            // console.log(item)
            checkAnyChange();
        } 
       
    }, [incidentDate, incidentInfo, amountApplied, amountLost, caseNumber, companyName, companyType, companyVAT, companyAddress, companyPhone, companyEmail])


    useEffect(() => {
        getDocuments()
        getBlacklist()
        getRepresentatives()
    }, []);

    

    useEffect(() => {
        const checkInterval = setInterval(() => {
            if (document.getElementById('change-button') != null) {
                if (change) {
                
                document.getElementById('change-button').disabled = false;
     
            } else {
                document.getElementById('change-button').disabled = true;
    
            }
            }
            setCheckCount(checkCount + 1)
        }, [1000])
 
        //Clearing the interval
        return () => clearInterval(checkInterval);
        
    }, [change, checkCount]);

    function checkAnyChange() {
        const inc_date = moment(item.incident_date).format('YYYY-MM-DD')
        checkChange(incidentDate, inc_date, 'inc-date')
        checkChange(incidentInfo, item.information, 'inc-info')
        checkChange(amountApplied, item.amount_applied, 'amount-applied')
        checkChange(amountLost, item.amount_lost, 'amount-lost')
        checkChange(caseNumber, item.case_number, 'case-number')
        checkChange(companyName, item.company_name, 'company-name')
        checkChange(companyReg, item.registration_number, 'company-reg')
        checkChange(companyType, item.company_type, 'company-type')
        checkChange(companyVAT, item.tax_number, 'company-vat')
        checkChange(companyAddress, item.address, 'company-address')
        checkChange(companyPhone, item.company_phone, 'company-phone')
        checkChange(companyEmail, item.company_email, 'company-email')
            
        if (
            checkChange(incidentDate, inc_date, 'inc-date')
            ||checkChange(incidentInfo, item.information, 'inc-info')
            ||checkChange(amountApplied, item.amount_applied, 'amount-applied')
            ||checkChange(amountLost, item.amount_lost, 'amount-lost')
            ||checkChange(caseNumber, item.case_number, 'case-number')
            ||checkChange(companyName, item.company_name, 'company-name')
            ||checkChange(companyReg, item.registration_number, 'company-reg')
            ||checkChange(companyType, item.company_type, 'company-type')
            ||checkChange(companyVAT, item.tax_number, 'company-vat')
            ||checkChange(companyAddress, item.address, 'company-address')
            ||checkChange(companyPhone, item.company_phone, 'company-phone')
            ||checkChange(companyEmail, item.company_email, 'company-email')
            
        ) {
            setChange(true);
        } else {
            setChange(false)
        }
       
       
    }


    const test_link = "http://localhost:3000/"
    const production_link = "https://apple-tree-server.vercel.app/"


    const getBlacklist = async () => {
        await axios.get(production_link + 'blacklist/')
        .then(response => {
            
            // setBlacklist(response.data)
            response.data.map((data) => {
                if (data.reference_number === reference) { 
                    setMyBlacklist(data);
                    setIncidentDate(moment(data.incident_date).format('YYYY-MM-DD'));
                    setIncidentInfo(data.information)
                    setAmountApplied(data.amount_applied);
                    setAmountLost(data.amount_lost)
                    setCaseNumber(data.case_number)

                    setCompanyName(data.company_name);
                    setCompanyReg(data.registration_number)
                    setCompanyType(data.company_type)
                    setCompanyVAT(data.tax_number)
                    setCompanyAddress(data.address)
                    setCompanyPhone(data.company_phone)
                    setCompanyEmail(data.company_email)
                    console.log(data)
                }
            })
        })

    }


    const getRepresentatives = async () => {
            await axios.get(production_link + 'representatives/')
            .then(response => {
                setRepresentatives(response.data)
                // console.log(response.data)
            })
    
        }





    const getDocuments = async () => {
        await axios.get(production_link+ 'documents/additional/')
        .then(response => setAdditionalDocuments(response.data))

        await axios.get(production_link+ 'documents/company/')
        .then(response => {
            setCompanyDocuments(response.data)})

        await axios.get(production_link+ 'documents/incident/')
        .then(response => setIncidentDocuments(response.data))

        await axios.get(production_link+ 'documents/people/')
        .then(response => setPeopleDocuments(response.data))
    }

    const downloadFile = async (filename, type) => {
        const downloadRef = ref(storage, `files/${filename}`)
        getDownloadURL(downloadRef)
        .then((url) => {

            if (type === 'ID') {
                setIDdownload(url)
                setIDname(filename)
            } 
            if (type === 'company') {
                setCompanyRegdownload(url)
                setCompanyReg(filename)
            }
            if (type === 'address') {
                setAddressdownload(url)
                setAddressName(filename)
            }
            if (type === 'contract') {
                setContractdownload(url)
                setContractName(filename)
            }
            
        })
        .catch(err => console.log(err))
        
    }

    const updateBlacklist = async () => {
        const dateIncident = new Date(incidentDate);
        const incidentID = item.incident_id;
        const companyID = item.company_id;
        
        await axios.post(production_link + 'update/blacklist', {
            user_id,
            incidentID,
            companyID,
            dateIncident,
            incidentInfo,
            amountApplied,
            amountLost,
            caseNumber,
            companyName,
            companyReg,
            companyType,
            companyVAT,
            companyAddress,
            companyPhone,
            companyEmail
        })
        .then((res) => {
            alert('Blacklist updated successfully!')
            console.log(res)
            window.location.reload(false)
        })
        .catch((err) => {
            console.warn(err)
        })
    }

    const displayDocuments = async (item) => {
        
        if (companyDocuments.length > 0) {
            companyDocuments.map(async (doc) => {
                if (doc.company_id === item.company_id) {
                    await downloadFile(doc.name, "company")
                }
            })
        }

        if (peopleDocuments.length > 0) {
            // console.log(item)
            peopleDocuments.map(async (doc) => {
                // console.log(doc)
                if (doc.id === item.person_id && doc.type === "ID document") {
                    await downloadFile(doc.name, "ID")
                } else if (doc.id === item.person_id && doc.type === "Proof of address") {
                    await downloadFile(doc.name, "address")
                }
            })
        }

        if (incidentDocuments.length > 0) {
            incidentDocuments.map(async (doc) => {
                if (doc.id === item.incident_id) {
                    await downloadFile(doc.name, "contract")
                }
            })
        }
    }

    const checkChange = (value, original, id) => {
       
        if (value !== original) {
            document.getElementById(id).classList.add('text-primary')
            return true
        } else {
            document.getElementById(id).classList.remove('text-primary')
            return false
        }
    }

    if (item) {
       return ( 
        <div className="w-100">

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Save changes?</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Save your changes? 
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-success" onClick={() => {
            updateBlacklist();
        }}>Yes</button>
      </div>
    </div>
  </div>
</div>
                        <div class="card text-center">
                            <h4 class="card-header display-6">
                                {item.company_name}
                            </h4>
                            <div class="card-body  d-flex flex-column jusify-content-center align-items-center">
                                <div className="card p-4 w-75">
                                    <h5 class="card-title">{item.category}</h5>
                                    <p class="card-text">Incident date: <br /><input style={{textAlign:"center", color:"lightgrey"}} type="date" onChange={(e) => {
                                        setIncidentDate(e.target.value);
                                    }} value={incidentDate} className="form-control"  id="inc-date"/></p>
                                    <p class="card-text">Information: <br /><input id="inc-info"  style={{textAlign:"center", color:"lightgrey"}} className="form-control" onChange={(e) => {
                                        setIncidentInfo(e.target.value)
                                    }} value={incidentInfo}/></p>
                                    <p class="card-text">Amount applied for: <br /><input id="amount-applied"  style={{textAlign:"center", color:"lightgrey"}}  className="form-control"  onChange={(e) => {
                                        setAmountApplied(e.target.value)
                                    }} value={amountApplied}/></p>
                                    <p  class="card-text">Amount lost: <br /><input id="amount-lost"  style={{textAlign:"center", color:"lightgrey"}}  className="form-control"  onChange={(e) => {
                                        // incidentLostChange(e.target.value)
                                        setAmountLost(e.target.value)
                                    }} value={amountLost}/></p>
                                    <p class="card-text">Case number: <br /><input id="case-number"  style={{textAlign:"center", color:"lightgrey"}}  className="form-control"  onChange={(e) => {
                                        setCaseNumber(e.target.value)
                                    }} value={caseNumber}/></p>
                                    <hr/>
                                    {/* {
                                            incidentDocuments.length > 0 &&
                                            <div>
                                                <h5 className="display-5 mb-3">Documents</h5>

                                                <p class="card-text" >Contract/Agreement: <br /></p><a className="text-secondary" href={Contractdownload} target="blank_">{contract}</a>

                                            </div>

                                        } */}
                                </div>
                                
                                
                                {/* <div className="d-flex flex-column align-items-center"> */}
                                <button class="btn btn-outline-secondary my-2" onClick={(e) => {
                                    e.preventDefault();
                                    if (showCompany) {
                                        setShowCompany(false)
                                    } else {
                                        setShowCompany(true)
                                    }
                                }}>Company Details</button>
                                {
                                    showCompany &&
                                    <div className="card p-4 w-75">
                                        <input id="company-name" className="mb-3 fs-1 form-control" style={{textAlign:"center", color:"lightgrey"}} value={companyName} onChange={(e) => {
                                            setCompanyName(e.target.value)
                                        }}/>
                                        <p class="">Company Registration: <br /><input id="company-reg" value={companyReg} className="form-control" style={{textAlign:"center", color:"lightgrey"}}  onChange={(e) => {
                                            setCompanyReg(e.target.value)
                                        }}/></p>
                                        <p class="">Company Type: <br />
                                        <select value={companyType} name="company-type" id="company-type" class="form-select my-3" style={{textAlign:"center", color:"lightgrey"}}  onChange={(e) => 
                                                {
                                                    setCompanyType(e.target.value)
                                                }
                                                }>
                                                <option selected >Choose company type <span className="text-danger">*</span></option>
                                                <option value="Private Company - (Pty) Ltd">Private Company - (Pty) Ltd</option>
                                                <option value="Public Company - Ltd">Public Company - Ltd</option>
                                                <option value="Non-Profit Company">Non-Profit Company</option>
                                                <option value="Close Corporation-CC">Close Corporation-CC</option>
                                            
                                            </select>
                                        </p>
                                        <p class="">VAT number: <br /><input id="company-vat" value={companyVAT} className="form-control"  style={{textAlign:"center", color:"lightgrey"}} onChange={(e) => {
                                            setCompanyVAT(e.target.value)
                                        }}/></p>
                                        <p class="">Company address: <br /><input id="company-address" value={companyAddress} className="form-control"  style={{textAlign:"center", color:"lightgrey"}} onChange={(e) => {
                                            setCompanyAddress(e.target.value)
                                        }}/></p>
                                        <p class="">Company phone: <br /><input id="company-phone" value={companyPhone} className="form-control"  style={{textAlign:"center", color:"lightgrey"}} onChange={(e) => {
                                            setCompanyPhone(e.target.value)
                                        }}/></p>
                                        <p class="">Company email: <br /><input id="company-email" value={companyEmail} className="form-control"  style={{textAlign:"center", color:"lightgrey"}} onChange={(e) => {
                                            setCompanyEmail(e.target.value)
                                        }}/></p>
                                        <hr/>
                                        {
                                            companyDocuments.length > 0 &&
                                            <div>
                                                <h5 className="display-5 mb-3">Documents</h5>

                                                <p class="card-text" >Company registration document: <br /></p><a className="text-secondary" href={Companydownload} target="blank_">{companyReg}</a>

                                            </div>

                                        }

                                    </div>
                                }
                                
                                {/* <button class="btn btn-outline-secondary my-4"  onClick={(e) => {
                                    e.preventDefault();
                                    if (showRep) {
                                        setShowRep(false)
                                    } else {
                                        setShowRep(true)
                                    }
                                }}>Representative Details</button>
                                
                                {
                                    showRep &&
                                    <div className="card p-4 w-75">
                                       {
                                        representatives.map((rep) => {
                                            if (item.company_id === rep.company_id) {
                                                return (
                                                    <div>
                                                        <h5 className="display-5 mb-3 my-3">{rep.first_name} {rep.last_name}</h5>
                                                        <p class="card-text">Title: <br /><span className="text-secondary">{rep.title}</span></p>
                                                        <p class="card-text">ID type: <br /><span className="text-secondary">{rep.id_type}</span></p>
                                                        <p class="card-text">ID number: <br /><span className="text-secondary">{rep.id_number}</span></p>
                                                        <p class="card-text">Date of birth: <br /><span className="text-secondary">{rep.date_of_birth}</span></p>
                                                        <p class="card-text">Gender: <br /><span className="text-secondary">{rep.gender}</span></p>
                                                        <p class="card-text">Marital: <br /><span className="text-secondary">{rep.marital}</span></p>
                                                        <p class="card-text">Phone: <br /><span className="text-secondary">0{rep.phone}</span></p>
                                                        <p class="card-text">Email: <br /><span className="text-secondary">{rep.email}</span></p>
                                                        <hr></hr>
                                                    </div>
                                                )
                                            }
                                        })
                                       }

                                        {
                                            peopleDocuments.length > 0 &&
                                            <div>
                                                <h5 className="display-5 mb-3 my-3">Documents</h5>
                                                
                                                <p class="card-text" >ID document: <br /></p><a className="text-secondary" href={IDdownload} target="blank_">{IDname}</a>

                                            </div>

                                        }

{
                                            peopleDocuments.length > 0 &&
                                            <div>
                                                <p class="card-text" >Proof of address: <br /></p><a className="text-secondary" href={Addressdownload} target="blank_">{address}</a>

                                            </div>

                                        }

                                    </div>
                                } */}
                                
                                {/* <button class="btn btn-outline-secondary my-2" onClick={(e) => {
                                    e.preventDefault();
                                    if (showDocs) {
                                        setShowDocs(false)
                                    } else {
                                        setShowDocs(true)
                                    }
                                }}>Additional Documents</button>
                                {
                                    showDocs && 
                                    <AddDocuments additionalDocuments={additionalDocuments} item={item}/>
                                } */}


                                {/* </div> */}
                                
                            </div>
                            <div class="card-footer text-muted">
                            <button data-bs-toggle="modal" data-bs-target="#exampleModal"  id="change-button" class={`btn btn-primary text-light `} >Change</button>
                            </div>
                        </div>
        </div>
        
    ); 
    } else {
        return (
            <div style={{height:"100vh"}} className="d-flex justify-content-center align-items-center ">
                
                            <CircleLoader size={200} color="#cdc59a"/>
            </div>
        )
    }
    
}
 
export default DetailEdit;